<template>
  <div class="subscription_packs_section" v-if="hasSubscriptionPacks">
    <div class="main_subscription_container">
      <div class="main_subscription_box">
        <SubscriptionPackButton
          :subscription_plan="subscription_plans[0]"
        />
      </div>
    </div>
    <div v-if="hasSubscriptionPacks" @click="toggleDropdown" class="packs_container">
      <div class="packs_box">
        <div class="dropdown-button">
          <span class="dropdown-button-left uppercase">{{
            $t("subscription_plan_packs.title")
          }}</span>
  
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="feather feather-chevron-down dropdown-button-right"
            :class="{ rotate: clickedDropDown }"
          >
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </div>
  
        <transition name="slide">
          <div class="packs_list" v-if="clickedDropDown">
            <SubscriptionPackButton
              class="subscription-item"
              v-for="subscription_plan in subscription_packs"
              :key="subscription_plan.id"
              :subscription_plan="subscription_plan"
            />
          </div>
        </transition>

      </div>
    </div>
  </div>
  <div class="subscription_packs_section" v-else-if="hasSubscriptionPlan">
    <div class="main_subscription_container">
      <div class="main_subscription_box">
        <SubscriptionPackButton
          :subscription_plan="subscription_plans[0]"
        />
      </div>
    </div>
  </div>
</template>
<script>
import SubscriptionPackButton from "./SubscriptionPackButton.vue";
export default {
  components: {
    SubscriptionPackButton,
  },
  props: {
    subscription_plans: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      clickedDropDown: true,
      subscription_packs: {},
    };
  },
  created() {
    this.subscription_packs = this.subscription_plans;
    //console.log(this.subscription_plans);
    //cargar en this.subscription_packs solo los elementos que tengan onward_subscription_plan_id != nul o vacio
    this.subscription_packs = this.subscription_packs.filter(
      (subscription_plan) => !!subscription_plan.is_plan_pack
    );
  },
  methods: {
    toggleDropdown() {
      this.clickedDropDown = !this.clickedDropDown;
    },
  },
  computed: {
    hasSubscriptionPacks() {
      return this.subscription_packs.length > 0;
    },
    hasSubscriptionPlan() {
      return this.subscription_plans.length > 0;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../styles/variables";

.subscription_packs_section {
  margin-top: 60px;
  margin-bottom: -20px;

  @media (max-width: 768px) {
    margin-top: 20px;
  }

  .main_subscription_container, .packs_container {
    margin: 20px auto;
    text-align: -webkit-center;
    width: 600px;
    max-width: 100%;
  }

  .main_subscription_container {
    .main_subscription_box {
      max-width: 90%;
    }
  }

  .packs_container {
    .packs_box {
      max-width: 90%;
      overflow: hidden;

      .dropdown-button {
        width: 100%;
        height: 50px;
        border: 2px solid #d0d0d061;
        background-color: #f5f5f5;
        align-content: center;
        z-index: 99;
        position: relative;
      }

      .packs_list {
        transform-origin: top;
        transition: transform 0.4s ease-in-out;
        overflow: hidden;
        z-index: 9;
        position: relative;

        .subscription-item {
          width: 100%;
          max-width: 100%;
          margin-top: 1em;
        }

        &.slide-enter, &.slide-leave-to{
          // transform: scaleY(0);
          transform: translateY(-100%);
        }
      }  
    }
  }
}

svg.feather.feather-chevron-down {
  vertical-align: middle;
  float: right;
  transform: rotate(-90deg);
  transition: transform 0.4s;

  &.rotate {
    transform: rotate(0deg);
  }
}
.dropdown-button-left {
  float: left;
  font-size: medium;
  font-weight: bold;
}
.dropdown-button-right {
  float: right;
  margin-right: 4%;
}
span.dropdown-button-left {
  padding-left: 3%;
}
.uppercase {
  text-transform: uppercase;
}
</style>
